import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import backButtonImage from '../../assets/navBar/backButtonIcon.png'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 20px;

  ${mediaQ('mobileAll', 'padding-left:10px')}
`
const BackButtonElement = styled.button`
  background: url(${backButtonImage});
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
  width: 30px;
  height: 30px;
  border: none;
  z-index: 2;
`
const BackButtonText = styled.span`
  font-size: 20px;
  margin-left: 10px;
  margin-left: 10px;
  font-family: 'Asap Condensed';
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.13;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #ffffff;
  z-index: 2;

  &.alt-color {
    color: #fe0da0;
  }
`

export const BackButton = ({
  place,
  specialLocation,
  alternativeColor,
  isActive,
}) => {
  const history = useHistory()
  return (
    <BackButtonContainer>
      <BackButtonElement
        onClick={() =>
          specialLocation
            ? isActive && history.push(`${specialLocation}`)
            : isActive && history.push(`${place}`)
        }
      />
      <BackButtonText className={alternativeColor && 'alt-color'}>
        {place}
      </BackButtonText>
    </BackButtonContainer>
  )
}

export default BackButton
